import { useEffect, useState } from "react";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  OutlinedInput,
  Select,
  Switch,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../../CustomComponents/CustomDateField";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";
import { v4 as uuid } from "uuid";
import { useRef } from "react";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";

const ReturnDetails = () => {
  const filterScreen = useSelector((state) => state.cov.filterScreen);
  //Flag used to show/Hide detail screen
  const [detailScreenView, setDetailScreenView] = useState(false);
  const [returnTypes, setReturnTypes] = useState([]);
  const [appNum, setAppNum] = useState();
  let mandateReturnList = ["Mandate EMI Receipt"];
  let checkReturnList = [
    "EMI Receipt",
    "Penal Receipt",
    "Pre Payment Receipt",
    "Other Receipts",
  ];
  const [activeFilterArray, setActiveFilterArray] = useState([]);
  const [returnValue, setReturnValues] = useState([]);
  const [returnDate, setReturnDate] = useState(null);
  const [mandateReturnFlag, setMandateReturnFlag] = useState(false);
  const [checkReturnFlag, setCheckReturnFlag] = useState(false);
  const [returnFilterSelectionValue, setReturnFilterSelectionValue] =
    useState(null);

  const dispatch = useDispatch();
  //shortcut key
  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "returnDetails",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = { clearRef: clearRef, searchButtonRef: searchButtonRef };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "i") {
        setReturnDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setReturnDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setReturnDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "returnDetails",
          })
        );
      }
    }
  };

  const mandateReturnFlagOnChangeHandler = (event) => {
    setMandateReturnFlag(event.target.checked);

    if (event.target.checked && checkReturnFlag) {
      setReturnTypes([...mandateReturnList, ...checkReturnList]);
    } else if (event.target.checked) {
      setReturnTypes(mandateReturnList);
    } else if (!event.target.checked && checkReturnFlag) {
      setReturnTypes(checkReturnList);
    } else if (!event.target.checked && !checkReturnFlag) {
      setReturnTypes([]);
    }
  };

  const checkReturnFlagOnChangeHandler = (event) => {
    setCheckReturnFlag(event.target.checked);
    if (event.target.checked && mandateReturnFlag) {
      setReturnTypes([...mandateReturnList, ...checkReturnList]);
    } else if (event.target.checked) {
      setReturnTypes(checkReturnList);
    } else if (!event.target.checked && mandateReturnFlag) {
      setReturnTypes(mandateReturnList);
    } else if (!event.target.checked && !mandateReturnFlag) {
      setReturnTypes([]);
    }
  };

  //Data Grid storage
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  //Methods
  const fetchButtonHandler = () => {
    getData(appNum);
  };
  const ClearButtonHandler = () => {
    setMandateReturnFlag(false);
    setReturnFilterSelectionValue(null);
    setCheckReturnFlag(false);
    setReturnTypes([]);
    setActiveFilterArray([]);
    setReturnDate(null);
    setDetailScreenView(false);
  };
  const getData = async (appNum) => {
    setDetailScreenView(true);
    try {
      const response = await axios.post(
        "/customerOneView/getReturnDetailData",
        {
          applicationNum: appNum,
          returnDate: returnDate,
          returnType: activeFilterArray,
          chequeReturn: checkReturnFlag,
          mandateReturn: mandateReturnFlag,
        }
      );
      const responseWithKey = response.data.map((record) => {
        return {
          ...record,
          id: Math.floor(Math.random() * 100 * Math.random()) + "-" + uuid(),
          returnDate: new Date(record.returnDate).toLocaleDateString("fr-FR"),
          returnAmount: record.returnAmount.toLocaleString("en-US"),
          returnCharge: record.returnCharge.toLocaleString("en-US"),
        };
      });
      setRows(responseWithKey);
    } catch {}
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const columnsData = [
    {
      field: "returnDate",
      headerName: "Return Date",
      headerAlign: "center",
      flex: 200,
      align: "left",
    },
    {
      field: "returnAmount",
      headerName: "Return Amount",
      headerAlign: "center",
      flex: 200,
      align: "left",
    },
    {
      field: "returnType",
      headerName: "Return Type",
      headerAlign: "center",
      flex: 240,
      align: "left",
    },
    {
      field: "returnCharge",
      headerName: "Return Charge",
      headerAlign: "center",
      flex: 180,
      align: "left",
    },
    {
      field: "returnReason",
      headerName: "Return Reason",
      headerAlign: "center",
      flex: 240,
      align: "left",
    },
  ];
  const onRemoveFieldClick = (value) => {
    const currentIndex = activeFilterArray.findIndex(
      (record) => record === value
    );
    const duplicate = [...activeFilterArray];
    duplicate.splice(currentIndex, 1);
    setActiveFilterArray([...duplicate]);
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setReturnValues(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    setAppNum(appNum);
    getData(appNum);
  }, [appNum]);
  return (
    <>
      <Box>
        <AccordianContainer
          title="Return Filter"
          initialOpen={true}
          sx={{
            border: "2px solid #1976d2",
          }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={3}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  variant="standard"
                  label="Return Date"
                  value={returnDate}
                  onChange={(value) => {
                    setReturnDate(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <>
                  <InputLabel
                    size="small"
                    sx={{
                      color: "#004A92",
                      mb: 2,
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    Return Types
                  </InputLabel>
                  <Box sx={{ display: "flex" }}>
                    <Box>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={mandateReturnFlag}
                              onChange={(event) => {
                                mandateReturnFlagOnChangeHandler(event);
                              }}
                              name="mandateReturnFlag"
                            />
                          }
                          label="Mandate Return"
                        />
                      </FormGroup>
                    </Box>
                    <Box>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={checkReturnFlag}
                              onChange={(event) => {
                                checkReturnFlagOnChangeHandler(event);
                              }}
                              name="checkReturnFlag"
                            />
                          }
                          label="Check Return"
                        />
                      </FormGroup>
                    </Box>
                  </Box>
                </>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Return Filter Selection"
                  label="Return Filter Selection"
                  required={false}
                  value={returnFilterSelectionValue}
                  autoCompleteValues={returnTypes}
                  onChange={(event, value) => {
                    if (value != "" && value != null) {
                      setReturnFilterSelectionValue(value);
                      let updatedFilterArray = [...activeFilterArray];
                      updatedFilterArray.push(value);
                      setActiveFilterArray([
                        ...new Set([...updatedFilterArray]),
                      ]);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <Box>
                  <Box>
                    <InputLabel
                      size="small"
                      sx={{
                        color: "#004A92",
                        mb: 2,
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Active Filters
                    </InputLabel>
                  </Box>
                  <Box>
                    {activeFilterArray.map((row, index) => (
                      <Chip
                        label={row}
                        variant={"contained"}
                        color="primary"
                        onDelete={() => {
                          onRemoveFieldClick(row);
                        }}
                        sx={{ marginTop: "2px", marginLeft: "2px" }}
                      />
                    ))}
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "8px" }}></Box>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+F" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={fetchButtonHandler}
                  ref={searchButtonRef}
                >
                  Search
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={ClearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </AccordianContainer>
        {detailScreenView && (
          <Box>
            <CustomDataGrid
              noDataMessage="No Data."
              noDataOnFilterMessage="No Data on Applied Filter."
              rows={rows}
              onPageSizeChange={(pageSize) => {
                setPageSize(pageSize);
              }}
              columns={columnsData}
              pageSize={pageSize}
              pageSizeOptions={[5, 10, 15, 20, 25]}
              gridLazyLoad={() => {}}
              onSortModelChange={() => {}}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
export default ReturnDetails;
